(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-demo-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeComparisons = (scope = document) => {
      const mediaItems = [];
      if (scope.matches && scope.matches('[data-before-after]')) mediaItems.push(scope);
      if (scope.querySelectorAll) mediaItems.push(...scope.querySelectorAll('[data-before-after]'));

      mediaItems.forEach((media) => {
        if (media.dataset.beforeAfterReady === 'true') return;
        const range = media.querySelector('[data-before-after-range]');
        if (!range) return;

        const updatePosition = () => {
          const position = `${range.value}%`;
          media.style.setProperty('--comparison-position', position);
          range.setAttribute('aria-valuetext', position);
        };

        range.addEventListener('input', updatePosition);
        updatePosition();
        media.dataset.beforeAfterReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeComparisons(), { once: true });
    } else {
      initializeComparisons();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeComparisons(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHomeDemos = (scope = document) => {
      const carousels = [];
      if (scope.matches && scope.matches('[data-home-demo]')) carousels.push(scope);
      if (scope.querySelectorAll) carousels.push(...scope.querySelectorAll('[data-home-demo]'));

      carousels.forEach((carousel) => {
        if (carousel.dataset.homeDemoReady === 'true') return;

        carousel.dataset.homeDemoReady = 'true';
        const slides = Array.from(carousel.querySelectorAll('[data-home-demo-slide]'));
        const previousButton = carousel.querySelector('[data-home-demo-prev]');
        const nextButton = carousel.querySelector('[data-home-demo-next]');
        const toggleButton = carousel.querySelector('[data-home-demo-toggle]');
        const currentLabel = carousel.querySelector('[data-home-demo-current]');
        const shouldAutoplay = carousel.dataset.homeDemoAutoplay === 'true';
        const interval = Number(carousel.dataset.homeDemoInterval) || 5000;
        let currentIndex = 0;
        let timer;
        let manuallyPaused = false;

        const updateSlide = (index) => {
          currentIndex = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === currentIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.inert = !isActive;
          });
          if (currentLabel) currentLabel.textContent = String(currentIndex + 1).padStart(2, '0');
        };

        const stopTimer = () => {
          window.clearInterval(timer);
        };

        const startTimer = () => {
          stopTimer();
          if (shouldAutoplay && !manuallyPaused && slides.length > 1) {
            timer = window.setInterval(() => updateSlide(currentIndex + 1), interval);
          }
        };

        previousButton?.addEventListener('click', () => {
          updateSlide(currentIndex - 1);
          startTimer();
        });

        nextButton?.addEventListener('click', () => {
          updateSlide(currentIndex + 1);
          startTimer();
        });

        toggleButton?.addEventListener('click', () => {
          manuallyPaused = !manuallyPaused;
          toggleButton.setAttribute('aria-pressed', String(manuallyPaused));
          toggleButton.textContent = manuallyPaused ? toggleButton.dataset.playLabel : toggleButton.dataset.pauseLabel;
          startTimer();
        });

        carousel.addEventListener('mouseenter', stopTimer);
        carousel.addEventListener('mouseleave', startTimer);
        carousel.addEventListener('focusin', stopTimer);
        carousel.addEventListener('focusout', startTimer);

        updateSlide(0);
        startTimer();
      });
    };

    const initializeWhenReady = () => initializeHomeDemos();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeWhenReady, { once: true });
    } else {
      initializeWhenReady();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeHomeDemos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
